import en from './en.json';
import no from './no.json';

export const resources = {
  en: { translation: en },
  no: { translation: no }
};

export default resources;
